import { UseMutateAsyncFunction, useMutation, useQueryClient } from '@tanstack/react-query';
import { IClinicalHistory } from '../types';
import axios from 'axios';

interface IClinicalHistoryService {
  updateClinicalHistory: UseMutateAsyncFunction<void, unknown, {
    data: Partial<IClinicalHistory>;
    uuid: string
  }, unknown>;
  deleteClinicalHistory: UseMutateAsyncFunction<void, unknown, string, unknown>;
  postClinicalHistory: UseMutateAsyncFunction<void, unknown, Partial<IClinicalHistory>, unknown>;
}

export default function usePatientClinicalHistoryService(
  patientUuid: string,
  queryKey: string[]
) {
  const queryClient = useQueryClient();

  const updateAction = useMutation({
    mutationFn: async ({
      data,
      uuid,
    }: {
      data: Partial<IClinicalHistory>;
      uuid: string;
    }) => {
      await axios.put(
        `/api/patients/${patientUuid}/clinical_history/${uuid}`,
        data
      );
      invalidateClinicalRecordQuery();
    },
  });

  const deleteAction = useMutation({
    mutationFn: async (uuid: string) => {
      await axios.delete(
        `/api/patients/${patientUuid}/clinical_history/${uuid}`
      );
      invalidateClinicalRecordQuery();
    },
  });
  const postAction = useMutation({
    mutationFn: async (data: Partial<IClinicalHistory>) => {
      await axios.post(`/api/patients/${patientUuid}/clinical_history`, data);
      invalidateClinicalRecordQuery();
    },
  });

  const invalidateClinicalRecordQuery = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey });
  };

  return {
    updateClinicalHistory: updateAction.mutateAsync,
    deleteClinicalHistory: deleteAction.mutateAsync,
    postClinicalHistory: postAction.mutateAsync,
  } as IClinicalHistoryService;
}
